import React from 'react';

import classnames from 'classnames';

class BaseSectionBookend extends React.Component {
	constructor() {
		super();

		this.state = {
			buttonHover: false,
			textIsHidden: true
		};

		this.hoverOnButton = this.hoverOnButton.bind(this);
		this.hoverOffButton = this.hoverOffButton.bind(this);

		this.wayPointEntered = this.wayPointEntered.bind(this);
	}

	hoverOnButton() {
		this.setState({buttonHover: true});
	}

	hoverOffButton() {
		this.setState({buttonHover: false});
	}

	wayPointEntered() {
		this.setState({textIsHidden: false});
	}

	getClassNames() {
		let classes = ['contents--centered'];

		if (this.state.textIsHidden) {
			classes.push('is-hidden');
		}

		return classnames(classes);
	}
}

export default BaseSectionBookend;



// WEBPACK FOOTER //
// ./src/components/Site/Home/BaseSectionBookend.js